const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '12px',
    flexShrink: 0,
  },
  // Grey: nobody can see this page yet. Same two badges as the table of contents, so the completion
  // page reads as the same kind of thing as every other page.
  draftBadge: {
    backgroundColor: '#F4F6F8',
    color: '#637381',
    fontFamily: 'Inter',
    fontSize: '10px',
    fontWeight: 600,
    borderRadius: '4px',
    padding: '1px 6px',
    whiteSpace: 'nowrap',
  },
  // Amber: the page is live, but what learners see is out of date.
  editedBadge: {
    backgroundColor: '#FFE9CC',
    color: '#B76E00',
    fontFamily: 'Inter',
    fontSize: '10px',
    fontWeight: 600,
    borderRadius: '4px',
    padding: '1px 6px',
    whiteSpace: 'nowrap',
  },
  action: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '4px',
    color: 'var(--mcg-dark, #002E47)',
    whiteSpace: 'nowrap',
    '&:hover': {
      cursor: 'pointer',
      opacity: 0.7,
    },
  },
  actionText: {
    color: 'var(--mcg-dark, #002E47)',
    fontFamily: 'Inter',
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '150%',
  },
})

export default styles
